import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { slugify } from './stringConvert';

export const genLinkSeo = (detailObj: {
  company?: string;
  startName?: string;
  startStateName?: string;
  startId?: number;
  endName?: string;
  endStateName?: string;
  endId?: number;
  seoPageAffix?: string;
}) => {
  const {
    company,
    startName,
    startStateName,
    startId,
    endName,
    endStateName,
    endId,
    seoPageAffix,
  } = detailObj;
  let path = '';
  if (!company && startName && endName) {
    path = `${seoPageAffix || '/vn'}/ve-may-bay/tu-${slugify(startName)}${
      startStateName && slugify(startName) !== slugify(startStateName || '')
        ? `-${slugify(startStateName || '')}`
        : ''
    }-di-${slugify(endName)}${
      endStateName && slugify(endName) !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${startId}.${endId}.vi`;
  } else if (!company && !startName && endName) {
    path = `${seoPageAffix || '/vn'}/ve-may-bay/di-${slugify(endName || '')}${
      endStateName && slugify(endName || '') !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${endId}.vi`;
  } else if (company && !startName && endName) {
    path = `${seoPageAffix || '/vn'}/ve-may-bay/${slugify(company)}-di-${slugify(endName || '')}${
      endStateName && slugify(endName || '') !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${endId}.vi`;
  } else if (company && startName && endName) {
    path = `${seoPageAffix || '/vn'}/ve-may-bay/${slugify(company)}-tu-${slugify(startName)}${
      startStateName && slugify(startName) !== slugify(startStateName || '')
        ? `-${slugify(startStateName || '')}`
        : ''
    }-di-${slugify(endName)}${
      endStateName && slugify(endName) !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${startId}.${endId}.vi`;
  }
  return (process.env.GOYOLO_URL || '') + path;
};

export const genLinkSeoVex = (detailObj: {
  company?: string;
  startName?: string;
  startStateName?: string;
  startId?: number;
  endName?: string;
  endStateName?: string;
  endId?: number;
}) => {
  const {
    company,
    startName,
    startStateName,
    startId,
    endName,
    endStateName,
    endId,
  } = detailObj;
  let path = '';
  if (!company && startName && endName) {
    path = `tu-${slugify(startName)}${
      startStateName && slugify(startName) !== slugify(startStateName || '')
        ? `-${slugify(startStateName || '')}`
        : ''
    }-di-${slugify(endName)}${
      endStateName && slugify(endName) !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${startId}.${endId}.vi`;
  } else if (!company && !startName && endName) {
    path = `di-${slugify(endName || '')}${
      slugify(endName || '') !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${endId}.vi`;
  } else if (company && !startName && endName) {
    path = `${slugify(company)}-di-${slugify(endName || '')}${
      endStateName && slugify(endName || '') !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${endId}.vi`;
  } else if (company && startName && endName) {
    path = `${slugify(company)}-tu-${slugify(startName)}${
      startStateName && slugify(startName) !== slugify(startStateName || '')
        ? `-${slugify(startStateName || '')}`
        : ''
    }-di-${slugify(endName)}${
      endStateName && slugify(endName) !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${startId}.${endId}.vi`;
  }
  return (process.env.GOYOLO_URL || '') + path;
};

export const genLinkSeoForVexPage = (detailObj: {
  company?: string;
  startName?: string;
  startStateName?: string;
  startId?: number;
  endName?: string;
  endStateName?: string;
  endId?: number;
  seoPageAffix?: string;
  lang?: ILangObj;
}) => {
  const {
    company,
    startName,
    startStateName,
    startId,
    endName,
    endStateName,
    endId,
    lang,
  } = detailObj;
  let path = '';
  if (!company && startName && endName) {
    path = `/vn/ve-may-bay/tu-${slugify(startName)}${
      startStateName && slugify(startName) !== slugify(startStateName || '')
        ? `-${slugify(startStateName || '')}`
        : ''
    }-di-${slugify(endName)}${
      endStateName && slugify(endName) !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${startId}.${endId}.vi`;
  } else if (!company && !startName && endName) {
    path = `/vn/ve-may-bay/di-${slugify(endName || '')}${
      endStateName && slugify(endName || '') !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${endId}.vi`;
  } else if (company && !startName && endName) {
    path = `/vn/ve-may-bay/${slugify(company)}-di-${slugify(endName || '')}${
      endStateName && slugify(endName || '') !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${endId}.vi`;
  } else if (company && startName && endName) {
    path = `/vn/ve-may-bay/${slugify(company)}-tu-${slugify(startName)}${
      startStateName && slugify(startName) !== slugify(startStateName || '')
        ? `-${slugify(startStateName || '')}`
        : ''
    }-di-${slugify(endName)}${
      endStateName && slugify(endName) !== slugify(endStateName || '')
        ? `-${slugify(endStateName || '')}`
        : ''
    }.${startId}.${endId}.vi`;
  }
  let url = (process.env.VEX_URL || '') + path;
  if (lang?.lang === 'en') {
    url = url.replace('ve-may-bay', 'flights').replace('-tu-', '-from-').replace('-di-', '-to-').replace('/tu-', '/from-')
      .replace('/di-', '/to-')
      .replace('.vi', '.en');
  }
  return url;
};
